module.exports = __webpack_public_path__ + "static/img/7690_phase_function_Paper_PointsHejduk_Prediction.cc89027.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7690_phase_function_Paper_PointsHejduk_Prediction.png
// module id = /q+j
// module chunks = 0